"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.benefits.precise_interactions': 'Precise and fast resolution of customer interactions, ensuring high quality and efficiency.',
    'onboarding.benefits.customer_satisfaction': 'Maximizing Customer Satisfaction indicators through improved and instant service.',
    'onboarding.benefits.workflow_automation': 'Comprehensive automation of key workflows, leading to significant reduction in operational costs and freeing up human resources.',
    'onboarding.benefits.real_time_insights': 'Effective use of real-time data to generate deep insights and drive sustainable business growth.',
};
